module.exports = __webpack_public_path__ + "img/logo2.431ca8c9.png";